import React from "react";

import { PrismicColor } from "utils";

import { Divider, Wrapper } from "components";

function PageDivider({ background }) {
  return (
    <Wrapper height="1px" bg={PrismicColor(background)}>
      <Divider />
    </Wrapper>
  );
}

export default PageDivider;
